export const CalendarColors = {
    "E2DAFF": { "bgColor": "#E2DAFF", "textColor": "purple", "name": "Light Purple" },
    "DAF8FF": { "bgColor": "#DAF8FF", "textColor": "blue", "name": "Light Blue" },
    "DAFFE2": { "bgColor": "#DAFFE2", "textColor": "green", "name": "Light Green" },
    "FFF8DA": { "bgColor": "#FFF8DA", "textColor": "#ffc02d", "name": "Light Yellow" },
    "FFE3DA": { "bgColor": "#FFE3DA", "textColor": "orange", "name": "Light Orange" },
    "FFDADA": { "bgColor": "#FFDADA", "textColor": "red", "name": "Light Red" },
    "A79C92": { "bgColor": "#A79C92", "textColor": "#fff", "name": "Standard Color" }
}